import { Alert, H4 } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from './BOSAlert.module.css';

const BOSAlert = ({
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isOpen,
  closeFunc,
  onConfirm,
  icon,
  intent,
  contentTitle,
  content,
}) => {
  return (
    <Alert
      className={
        intent === 'warning' || intent === 'danger'
          ? styles.warning_alert
          : styles.primary_alert
      }
      cancelButtonText={cancelText}
      confirmButtonText={confirmText}
      icon={icon}
      intent={intent}
      isOpen={isOpen}
      onConfirm={onConfirm}
      onCancel={closeFunc}
      canOutsideClickCancel>
      <H4 className={styles.content_title}>{contentTitle}</H4>
      {content}
    </Alert>
  );
};

BOSAlert.propTypes = {
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  isOpen: PropTypes.bool,
  closeFunc: PropTypes.func,
  onConfirm: PropTypes.func,
  intent: PropTypes.string,
  icon: PropTypes.string,
  contentTitle: PropTypes.string,
  content: PropTypes.node,
};

export default BOSAlert;
